import { render, staticRenderFns } from "./QuizzesCreate.vue?vue&type=template&id=caa58e9c&"
import script from "./QuizzesCreate.vue?vue&type=script&lang=js&"
export * from "./QuizzesCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports